import { render, staticRenderFns } from "./deviceStatistics.vue?vue&type=template&id=6c88e928&scoped=true"
import script from "./deviceStatistics.vue?vue&type=script&lang=js"
export * from "./deviceStatistics.vue?vue&type=script&lang=js"
import style0 from "./deviceStatistics.vue?vue&type=style&index=0&id=6c88e928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88e928",
  null
  
)

export default component.exports